<ng-container>
  <app-table class="third-party-search-result-table" [displayStyle]="vehicleTableStyle$ | async">
    <table
      cdk-table
      [dataSource]="thirdPartySearchResults"
      >
      <caption class="d-none">{{tableCaption}}</caption>
      <tr class="third-party-table-header" cdk-header-row *cdkHeaderRowDef="columns"></tr>
      <tr cdk-row class="third-party-table-row" *cdkRowDef="let inventoryRecord; columns: columns"></tr>
      <ng-container cdkColumnDef="vin">
        <th scope="col" cdk-header-cell *cdkHeaderCellDef>
          <span aria-label="VIN">VIN</span>
        </th>
        <td cdk-cell *cdkCellDef="let inventoryRecord">
          <a class="fw-bold" href="javascript:void(0)" (click)="proceedWithThirdPartyVin.emit(inventoryRecord)"
          >{{ inventoryRecord.vin }}</a>
        </td>
      </ng-container>
      <ng-container cdkColumnDef="vendor">
        <th scope="col" cdk-header-cell *cdkHeaderCellDef>
          <span aria-label="{{thirdPartyTableTranslations.vendor}}">{{thirdPartyTableTranslations.vendor}}</span>
        </th>
        <td cdk-cell *cdkCellDef="let inventoryRecord">{{ inventoryRecord.vendorId || notAvailableText }}</td>
      </ng-container>
      <ng-container cdkColumnDef="year">
        <th scope="col" cdk-header-cell *cdkHeaderCellDef>
          <span aria-label="{{thirdPartyTableTranslations.year}}">{{thirdPartyTableTranslations.year}}</span>
        </th>
        <td cdk-cell *cdkCellDef="let inventoryRecord">{{ inventoryRecord.year || notAvailableText }}</td>
      </ng-container>
      <ng-container cdkColumnDef="make">
        <th scope="col" cdk-header-cell *cdkHeaderCellDef>
          <span aria-label="{{thirdPartyTableTranslations.make}}">{{thirdPartyTableTranslations.make}}</span>
        </th>
        <td cdk-cell *cdkCellDef="let inventoryRecord">{{ inventoryRecord.make || notAvailableText }}</td>
      </ng-container>
      <ng-container cdkColumnDef="model">
        <th scope="col" cdk-header-cell *cdkHeaderCellDef>
          <span aria-label="{{thirdPartyTableTranslations.model}}">{{thirdPartyTableTranslations.model}}</span>
        </th>
        <td cdk-cell *cdkCellDef="let inventoryRecord">{{ inventoryRecord.model || notAvailableText }}</td>
      </ng-container>
      <ng-container cdkColumnDef="trim">
        <th scope="col" cdk-header-cell *cdkHeaderCellDef>
          <span aria-label="{{thirdPartyTableTranslations.trim}}">{{thirdPartyTableTranslations.trim}}</span>
        </th>
        <td cdk-cell *cdkCellDef="let inventoryRecord">{{ inventoryRecord.series || notAvailableText }}</td>
      </ng-container>
      <ng-container cdkColumnDef="dealerStockNumber">
        <th scope="col" cdk-header-cell *cdkHeaderCellDef>
          <span
          aria-label="{{thirdPartyTableTranslations.dealerStockNumber}}">{{thirdPartyTableTranslations.dealerStockNumber}}</span>
        </th>
        <td cdk-cell *cdkCellDef="let inventoryRecord">{{ inventoryRecord.dealerStockNumber || notAvailableText }}</td>
      </ng-container>
      <ng-container cdkColumnDef="odometer">
        <th scope="col" cdk-header-cell *cdkHeaderCellDef>
          <span aria-label="{{thirdPartyTableTranslations.odometer}}">{{thirdPartyTableTranslations.odometer}}</span>
        </th>
        <td cdk-cell *cdkCellDef="let inventoryRecord">{{ (inventoryRecord.mileage | number) || notAvailableText }}</td>
      </ng-container>
    </table>

    <!--    Mobile Cards -->
    @for (vehicle of thirdPartySearchResults; track vehicle) {
      <app-table-card>
        <app-table-card-header>
          <div class="third-party-vehicle-card-header__title">
            <a class="fw-bold" [attr.aria-label]="'VIN: ' + vehicle.vin" href="javascript:void(0)"
            (click)="proceedWithThirdPartyVin.emit(vehicle)"> {{ vehicle.vin }}</a>
          </div>
        </app-table-card-header>
        <app-table-card-body>
          <dl class="third-party-vehicle-card__info-list">
            <div class="third-party-vehicle-card-body__col">
              <div class="column-grouping">
                <dt>{{thirdPartyTableTranslations.vendor}}:</dt>
                <dd>
                  <span>{{ vehicle.vendorId || notAvailableText }}</span>
                </dd>
              </div>
              <div class="column-grouping">
                <dt>{{thirdPartyTableTranslations.make}}:</dt>
                <dd>
                  <span>{{ vehicle.make || notAvailableText }}</span>
                </dd>
              </div>
              <div class="column-grouping">
                <dt>{{thirdPartyTableTranslations.trim}}:</dt>
                <dd>
                  <span>{{ vehicle.series || notAvailableText }}</span>
                </dd>
              </div>
              <div class="column-grouping">
                <dt>{{thirdPartyTableTranslations.odometer}}:</dt>
                <dd>
                  <span>{{ vehicle.mileage || notAvailableText }}</span>
                </dd>
              </div>
            </div>
            <div class="third-party-vehicle-card-body__col">
              <div class="column-grouping">
                <dt>{{thirdPartyTableTranslations.year}}:</dt>
                <dd>
                  <span>{{ vehicle.year }}</span>
                </dd>
              </div>
              <div class="column-grouping">
                <dt>{{thirdPartyTableTranslations.model}}:</dt>
                <dd>
                  <span>{{ vehicle.model || notAvailableText }}</span>
                </dd>
              </div>
              <div class="column-grouping">
                <dt>{{thirdPartyTableTranslations.dealerStockNumber}}:</dt>
                <dd>
                  <span>{{ vehicle.dealerStockNumber || notAvailableText }}</span>
                </dd>
              </div>
            </div>
          </dl>
        </app-table-card-body>
      </app-table-card>
    }
  </app-table>
</ng-container>
